"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExceptionReasons = exports.ExceptionContextEnum = void 0;
const frontend_infra_auth_1 = require("@forto-dev/frontend-infra-auth");
const frontend_infra_reactquery_1 = require("@forto-dev/frontend-infra-reactquery");
const ui_platform_http_1 = require("@forto-dev/ui-platform-http");
const ConfigContext_1 = require("../../../lib/ConfigContext");
var ExceptionContextEnum;
(function (ExceptionContextEnum) {
    ExceptionContextEnum["Cargo"] = "cargo";
    ExceptionContextEnum["Containers"] = "containers";
    ExceptionContextEnum["Customs"] = "customs";
    ExceptionContextEnum["Insurance"] = "insurance";
    ExceptionContextEnum["MainCarriage"] = "mainCarriage";
    ExceptionContextEnum["OnCarriage"] = "onCarriage";
    ExceptionContextEnum["PreCarriage"] = "preCarriage";
    ExceptionContextEnum["Services"] = "services";
    ExceptionContextEnum["FinancialControlling"] = "finance";
    ExceptionContextEnum["ExceptionMapping"] = "exceptionMapping";
    ExceptionContextEnum["VerifiedGrossMargin"] = "verifiedGrossMargin";
})(ExceptionContextEnum || (exports.ExceptionContextEnum = ExceptionContextEnum = {}));
const useFetchExceptionReasons = () => {
    const { state: { token }, } = (0, frontend_infra_auth_1.useAuth)();
    const config = (0, ConfigContext_1.useConfigContext)();
    const url = `${config.SHIPPING_ENDPOINT}/v3/reasons`;
    const fetchExceptionReasons = async () => {
        const response = await ui_platform_http_1.HttpBaseApi.get(url, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    };
    return fetchExceptionReasons;
};
const useExceptionReasons = (isInternalActivitiesEnabled) => {
    const fetchExceptionReasons = useFetchExceptionReasons();
    return (0, frontend_infra_reactquery_1.useQuery)({
        queryKey: ['exceptionReasons'],
        queryFn: fetchExceptionReasons,
        enabled: isInternalActivitiesEnabled,
    });
};
exports.useExceptionReasons = useExceptionReasons;
//# sourceMappingURL=getExceptionReasons.js.map